module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editVatRatesModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.EVR000) + " - " + _vm._s(_vm.lang.EVR001))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectEditVatRatesCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectEditVatRatesCountry"
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, _vm._l((_vm.globals.countryList), function(name, code) {
    return _c('option', {
      key: code,
      domProps: {
        "value": code
      }
    }, [_vm._v("\n                " + _vm._s(name) + "\n              ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditVatRatesValue"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR003) + " (%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.vatRatePercentage),
      expression: "vatRatePercentage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputEditVatRatesValue",
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.vatRatePercentage)
    },
    on: {
      "change": function($event) {
        _vm.vatDataDirty = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vatRatePercentage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.vatDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveVatRates()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR005) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64dc79cf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/EditVatRatesModal.vue
// module id = 1792
// module chunks = 2